/* ═══════════════════════════════════════════════════════════
   js/push.js — Web Push подписка БРОНИДОМ
   Подключается через footer.php, работает после SW регистрации
   ═══════════════════════════════════════════════════════════ */
(() => {
  'use strict';

  // VAPID public key из мета-тега (устанавливается PHP)
  const vapidMeta = document.querySelector('meta[name="vapid-key"]');
  if (!vapidMeta) return;

  const VAPID_PUBLIC = vapidMeta.content;
  const API = 'push_api.php';

  // ── Утилиты ──────────────────────────────────────────────

  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = atob(base64);
    const arr = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
    return arr;
  }

  // ── Проверка поддержки ───────────────────────────────────

  function isPushSupported() {
    return 'serviceWorker' in navigator
        && 'PushManager' in window
        && 'Notification' in window;
  }

  // ── Подписка ─────────────────────────────────────────────

  async function subscribePush(buildingIds, city) {
    if (!isPushSupported()) return null;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    const reg = await navigator.serviceWorker.ready;
    let subscription = await reg.pushManager.getSubscription();

    if (!subscription) {
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC)
      });
    }

    const key = subscription.getKey('p256dh');
    const auth = subscription.getKey('auth');

    const body = {
      endpoint: subscription.endpoint,
      p256dh: btoa(String.fromCharCode.apply(null, new Uint8Array(key))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, ''),
      auth: btoa(String.fromCharCode.apply(null, new Uint8Array(auth))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    };

    if (buildingIds) body.building_ids = buildingIds;
    if (city) body.city = city;

    try {
      const res = await fetch(API + '?action=subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      return await res.json();
    } catch (e) {
      console.warn('[push] subscribe error:', e);
      return null;
    }
  }

  // ── Отписка ──────────────────────────────────────────────

  async function unsubscribePush() {
    if (!isPushSupported()) return;

    const reg = await navigator.serviceWorker.ready;
    const subscription = await reg.pushManager.getSubscription();
    if (!subscription) return;

    await subscription.unsubscribe();

    try {
      await fetch(API + '?action=unsubscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ endpoint: subscription.endpoint })
      });
    } catch (e) {
      console.warn('[push] unsubscribe error:', e);
    }
  }

  // ── Проверка статуса ─────────────────────────────────────

  async function getPushStatus() {
    if (!isPushSupported()) return { subscribed: false };

    const reg = await navigator.serviceWorker.ready;
    const subscription = await reg.pushManager.getSubscription();
    if (!subscription) return { subscribed: false };

    try {
      const res = await fetch(API + '?action=status', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ endpoint: subscription.endpoint })
      });
      return await res.json();
    } catch (e) {
      return { subscribed: false };
    }
  }

  // ── Обновление подписки на ЖК ────────────────────────────

  async function updatePushBuildings(buildingIds) {
    if (!isPushSupported()) return;

    const reg = await navigator.serviceWorker.ready;
    const subscription = await reg.pushManager.getSubscription();
    if (!subscription) return;

    try {
      await fetch(API + '?action=updateBuildings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          endpoint: subscription.endpoint,
          building_ids: buildingIds
        })
      });
    } catch (e) {
      console.warn('[push] updateBuildings error:', e);
    }
  }

  // ── UI: кнопки подписки ──────────────────────────────────

  function initPushButtons() {
    document.querySelectorAll('[data-push-subscribe]').forEach(function(btn) {
      const buildingId = btn.dataset.pushSubscribe;

      // Начальное состояние
      getPushStatus().then(function(status) {
        if (status.subscribed && status.buildings && status.buildings.includes(parseInt(buildingId))) {
          btn.textContent = 'Вы подписаны \u2713';
          btn.classList.add('push-subscribed');
        }
      });

      btn.addEventListener('click', async function() {
        if (btn.classList.contains('push-subscribed')) {
          // Уже подписан — отписать от этого ЖК
          const status = await getPushStatus();
          const buildings = (status.buildings || []).filter(function(id) { return id !== parseInt(buildingId); });
          if (buildings.length === 0) {
            await unsubscribePush();
          } else {
            await updatePushBuildings(buildings);
          }
          btn.textContent = 'Подписаться на цены';
          btn.classList.remove('push-subscribed');
        } else {
          // Подписать
          const status = await getPushStatus();
          const buildings = status.buildings || [];
          buildings.push(parseInt(buildingId));
          await subscribePush(buildings);
          btn.textContent = 'Вы подписаны \u2713';
          btn.classList.add('push-subscribed');
          if (typeof ymGoal === 'function') ymGoal('push_subscribe');
        }
      });
    });
  }

  // ── Init ─────────────────────────────────────────────────

  if (isPushSupported()) {
    document.addEventListener('DOMContentLoaded', initPushButtons);
  }

  // Expose
  window.subscribePush = subscribePush;
  window.unsubscribePush = unsubscribePush;
  window.getPushStatus = getPushStatus;
})();
